import { apiUri } from '../appConfig';

const promotionList = (type = '') => (
	fetch(`${apiUri}/promotion${type ? `?type=${type}` : ''}`)
		.then((res) => res.json())
		.catch((err) => console.error(err))
);

export default promotionList;



// WEBPACK FOOTER //
// ./src/js/request/promotionList.js